// URL-safe base64 encode/decode of a JSON snapshot passed to the public
// onboarding pages via the `?s=` query param. This is obfuscation only (no
// signature) - the public pages are mock and persist nothing. If these pages
// are ever made real, switch to a signed token (e.g. JWT) here.

export const encodeSnapshot = (value: unknown): string => {
  try {
    const bytes = new TextEncoder().encode(JSON.stringify(value));
    let binary = '';
    bytes.forEach((b) => {
      binary += String.fromCharCode(b);
    });
    return window.btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  } catch {
    return '';
  }
};

export const decodeSnapshot = <T>(value: string): T | null => {
  try {
    const padded = value
      .replace(/-/g, '+')
      .replace(/_/g, '/')
      .padEnd(Math.ceil(value.length / 4) * 4, '=');
    const binary = window.atob(padded);
    const bytes = Uint8Array.from(binary, (c) => c.charCodeAt(0));
    return JSON.parse(new TextDecoder().decode(bytes)) as T;
  } catch {
    return null;
  }
};
